import DashboardLayout from './DashboardLayout';

/**
 * Example of use:
 * ----------------
 * import DashboardLayout from 'src/components/dashboardLayout';
 * import PageContent from 'src/components/page/pageContent';
 * import PageTitle from 'src/components/page/pageTitle';
 *
 * <DashboardLayout>
 *   <PageTitle title='TITLE'/>
 *   <PageContent>TABLE PLACE</PageContent>
 * </DashboardLayout>
 */
export default DashboardLayout;
